import { APP_CONFIG, APP_VERSION, AppConfig, AppEnvironment, AuthenticationConfig, AUTH_CONFIG, loadAppConfig } from 'config-data';
import { BASE_PATH as PRODUCTS_API_BASE_PATH } from '@idealsupply/products-api-angular-client';

export const environment = () => {
  const loaded = loadAppConfig<AppConfig>() ?? ({} as AppConfig);

  console.info('Loaded config from dom', loaded);

  loaded.appVersion ??= '0.0.0';

  loaded.auth ??= {} as AuthenticationConfig;
  loaded.auth.apiRoot ??= 'https://api.idealsupply.com';
  loaded.auth.stsAuthority ??= 'https://auth.idealsupply.com';

  loaded.apiRewrites ??= {
    'https://api.idealsupply.com': loaded.auth.apiRoot,
    'https://auth.idealsupply.com': loaded.auth.stsAuthority,
  };

  console.info('Loaded applying config to environment', loaded);

  return {
    env: 'production',
    ...loaded,
    providers: [
      {
        provide: PRODUCTS_API_BASE_PATH,
        useValue: 'https://api.idealsupply.com/products/v1',
      },
      {
        provide: AUTH_CONFIG,
        useValue: loaded.auth,
      },
      {
        provide: APP_CONFIG,
        useValue: loaded,
      },
      {
        provide: APP_VERSION,
        useValue: loaded.appVersion,
      },
    ],
  } as AppEnvironment;
};
